export default "__VITE_ASSET__5eb19a82__"